import { createSelector } from '@reduxjs/toolkit';
import type { AiApiSpec_GenerateNoteQueueRequestBody } from '@timelyapp/integration-cloud-api-spec';
import { getCurrentAccountId } from 'redux/selectors/accounts';
import { getDerivedDatesInfo } from 'redux/selectors/calendar.filter';
import { getHourDraft } from 'redux/selectors/hours.draft.base';
import { fromISO } from 'utils/luxon-helpers';

/**
 * Builds they query payload for the note generation request.
 * @see requestHourNoteGeneration / AddToGenerateNoteQueue
 */
type Partial_AiApiSpec_GenerateNoteQueueRequestBody = Omit<
  AiApiSpec_GenerateNoteQueueRequestBody,
  'tic_user_id' | 'timely_user_id'
>;
export const getRequestHourNoteGenerationQuery = createSelector(
  [getCurrentAccountId, getDerivedDatesInfo, getHourDraft],
  (timely_account_id, dateMeta, hourDraft): Partial_AiApiSpec_GenerateNoteQueueRequestBody => {
    const hour = hourDraft
      ? {
          id: hourDraft.id ?? undefined,
          project_id: hourDraft.project ?? undefined,
          label_ids: hourDraft.label_ids,
          timestamps: hourDraft.timestamps.map(ts => ({
            from: ts.from,
            to: ts.to,
            entry_ids: ts.entry_ids.map(id => id.toString()),
          })),
        }
      : undefined;

    const firstTimestamp = hourDraft?.timestamps.at(0)?.from;
    const lastTimestamp = hourDraft?.timestamps.at(-1)?.to;

    const since = firstTimestamp ? fromISO(firstTimestamp).toISO() : dateMeta.since;
    const to = lastTimestamp ? fromISO(lastTimestamp).toISO() : dateMeta.upto;

    return {
      timely_account_id,
      since,
      to,
      hour,
      style: 'all',
    } satisfies Partial_AiApiSpec_GenerateNoteQueueRequestBody;
  }
);
